import { Box, Button, Container, Input, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import swal from "sweetalert";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import "./account.css";
import { theme } from "../../theme";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function UserProfile() {
    const { id } = useParams();
    const [isShow, setShow] = useState(false);
    const [data, setData] = useState(null);
    const [load, setLoad] = useState(false);
    const [profile, setProfile] = useState(null);
    const [bank, setBank] = useState(null);
    const [history, setHistory] = useState(null);
    const [dataTable, setDatatable] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(new Date());
    const [api, setAPI] = useState(null);
    const [isLoading, setLoading] = useState(true);
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    useEffect(() => {
        if (id && load == false) {
            axios
                .post(`${process.env.REACT_APP_API_URL}/bank/getBankUser`, { id: id })
                .then((res) => {
                    setData(res.data.data);
                    setLoad(true);
                })
                .catch((res) => setData(null));
        }
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/user/${id}`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                }
            })
            .catch((res) => setProfile(null));
        axios
            .get(`${process.env.REACT_APP_API_URL}/history/historyuser/${id}`, {})
            .then((res) => {
                setHistory(res.data.data);
                setLoading(false);
            })
            .catch((res) => setHistory(null));
    }, [load]);
    const handleSubmit = (e) => {
        e.preventDefault();
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/changepassword`, {
                id: id,
                password: e.target.password.value
            })
            .then((res) => {
                setLoad(false);
                swal("Cập nhật thành công", "", "success");
            })
            .catch((err) => {
                swal("Thông báo", "Đã xảy ra lỗi, vui lòng thử lại!", "error");
                setData(null);
            });
    };
    const handleSubmit2 = (e) => {
        e.preventDefault();
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/changepassword`, {
                id: id,
                paypwd: e.target.paypwd.value
            })
            .then((res) => {
                setLoad(false);
                swal("Cập nhật thành công", "", "success");
            })
            .catch((err) => {
                swal("Thông báo", "Đã xảy ra lỗi, vui lòng thử lại!", "error");
                setData(null);
            });
    };
    const handleSubmitBank = (e) => {
        e.preventDefault();
        const formData = {
            id: bank._id,
            name_bank: e.target.name_bank.value,
            stk: e.target.stk.value,
            fullname: e.target.fullname.value
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/bank/updateBank`, formData)
            .then((res) => {
                setShow(false);
                swal("Cập nhật thành công", "", "success");
                setLoad(false);
            })
            .catch((err) => {
                setShow(false);
                swal("Thông báo", "Đã xảy ra lỗi, vui lòng thử lại!", "error");
                setLoad(false);
            });
    };
    const [employee, setEmployee] = useState();
    useEffect(() => {
        if (load == false) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/auth/getall`, {})
                .then((res) => {
                    localStorage.setItem("data", JSON.stringify(res.data.data));
                    setLoad(true);
                })
                .then((res) => setLoad(true));
            axios
                .get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`, {})
                .then((res) => {
                    localStorage.setItem("data1", JSON.stringify(res.data.data));
                    setEmployee(res.data.data);
                    setLoad(true);
                })
                .then((res) => setLoad(true));
        }
    }, [load]);

    useEffect(() => {
        if (load == true) {
            setLoading(true);
            axios
                .get(`${process.env.REACT_APP_API_URL}/statistic/getallcustomer?dateStart=${startDate}&endDate=${endDate}&id=${id}`, {})
                .then((res) => {
                    setDatatable(res.data.data);
                    setLoading(false);
                })
                .catch((err) => setLoading(false));
        }
    }, [endDate, startDate, load]);

    /*useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/casino/history`, {})
            .then((res) => {
                const betHistory = JSON.parse(res.data.data.result);
                const newdata = betHistory.filter((item) => item.member === profile.username);
                setAPI(newdata);
            })
            .catch((err) => console.log(err));
    }, [profile]);*/
    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    {
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 8
                            }}>
                            {isLoading ? (
                                <div className="loading" style={{ maxWidth: "100%" }}>
                                    <div className="loader"></div>
                                </div>
                            ) : null}
                            <Container maxWidth={false}>
                                <div style={{ fontSize: "25px", fontWeight: 700 }}>Chỉnh sửa thông tin</div>
                                <div className="item_accountprofile">
                                    <div className="account_profile">
                                        <div className="titleitem">Thông tin cơ bản</div>
                                        {profile != null ? (
                                            <>
                                                <div className="avb_">
                                                    <div className="detail_user">
                                                        <div className="username_">Tên đăng nhập</div>
                                                        <div className="username_">{profile.username}</div>
                                                    </div>
                                                    <form onSubmit={handleSubmit}>
                                                        <div className="detail_user">
                                                            <div className="username_">Mật khẩu</div>
                                                            <TextField name="password" />
                                                            <Button type="submit">Xác nhận</Button>
                                                        </div>
                                                    </form>
                                                    <form onSubmit={handleSubmit2}>
                                                        <div className="detail_user">
                                                            <div className="username_">Mật khẩu rút tiền</div>
                                                            <TextField name="paypwd" defaultValue={profile?.paypwd} />
                                                            <Button type="submit">Xác nhận</Button>
                                                        </div>
                                                    </form>
                                                    <div className="detail_user">
                                                        <div className="username_">Số dư</div>
                                                        <div className="username_">{Math.floor(profile.money).toLocaleString("vi-VN")}</div>
                                                    </div>
                                                    <form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            const formData = {
                                                                id: id,
                                                                level: e.target.vip.value
                                                            };
                                                            axios
                                                                .post(`${process.env.REACT_APP_API_URL}/auth/update`, formData)
                                                                .then((res) => swal("Update level user thành công!", "", "success"))
                                                                .catch(() => swal("Update không thành công", "", "error"));
                                                        }}>
                                                        <div className="detail_user">
                                                            <div className="username_">Vip</div>
                                                            <div className="username_">
                                                                <select name="vip" id="vip">
                                                                    <option selected={profile?.level === 0} value="0">
                                                                        1
                                                                    </option>
                                                                    <option selected={profile?.level === 2} value="2">
                                                                        2
                                                                    </option>
                                                                    <option selected={profile?.level === 3} value="3">
                                                                        3
                                                                    </option>
                                                                    <option selected={profile?.level === 4} value="4">
                                                                        4
                                                                    </option>
                                                                    <option selected={profile?.level === 5} value="5">
                                                                        5
                                                                    </option>
                                                                    <option selected={profile?.level === 6} value="6">
                                                                        6
                                                                    </option>
                                                                    <option selected={profile?.level === 7} value="7">
                                                                        7
                                                                    </option>
                                                                    <option selected={profile?.level === 8} value="8">
                                                                        8
                                                                    </option>
                                                                    <option selected={profile?.level === 9} value="9">
                                                                        9
                                                                    </option>
                                                                    <option selected={profile?.level === 10} value="10">
                                                                        10
                                                                    </option>
                                                                </select>
                                                                <Button type="submit">Xác nhận</Button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                    <div className="detail_user">
                                                        <div className="username_">Tổng cược</div>
                                                        <div className="username_">{Number(profile.totalbet).toLocaleString("vi-VN")}</div>
                                                    </div>
                                                    <div className="detail_user">
                                                        <div className="username_">Tổng cược API</div>
                                                        <div className="username_">{Number(profile.totalbetapi).toLocaleString("vi-VN")}</div>
                                                    </div>
                                                    <div className="detail_user">
                                                        <div className="username_">Admin đã cộng</div>
                                                        <div className="username_">{Number(profile.adminadd).toLocaleString("vi-VN")}</div>
                                                    </div>
                                                    <div className="detail_user">
                                                        <div className="username_">Admin đã trừ</div>
                                                        <div className="username_">{Number(profile.admintru).toLocaleString("vi-VN")}</div>
                                                    </div>
                                                    <div className="detail_user">
                                                        <div className="username_">Admin đã thưởng</div>
                                                        <div className="username_">{Number(profile.adminthuong).toLocaleString("vi-VN")}</div>
                                                    </div>
                                                    <div className="detail_user">
                                                        <div className="username_">Tiền đã đặt cược</div>
                                                        <div className="username_">{Number(profile.totalbet).toLocaleString("vi-VN")}</div>
                                                    </div>
                                                    <div className="detail_user">
                                                        <div className="username_">Tiền đã thắng</div>
                                                        <div className="username_">{Number(profile.totalwin).toLocaleString("vi-VN")}</div>
                                                    </div>
                                                    <div className="detail_user">
                                                        <div className="username_">Ngày tạo</div>
                                                        <div className="username_">{formatDate(new Date(profile.createdAt))}</div>
                                                    </div>
                                                    <div className="detail_user">
                                                        <div className="username_">Người giới thiệu</div>
                                                        <div className="username_">
                                                            {employee && employee.find((x) => x.code === profile.aff)?.username
                                                                ? employee.find((x) => x.code === profile.aff)?.username
                                                                : "không nhập mã"}
                                                        </div>
                                                    </div>
                                                    <form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            const formData = {
                                                                id: id,
                                                                sdt: e.target.sdt.value,
                                                                name: e.target.name.value,
                                                                aff: e.target.aff.value
                                                            };
                                                            axios
                                                                .post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${id}`, formData)
                                                                .then((res) => swal("Update thành công!", "", "success"))
                                                                .catch(() => swal("Update không thành công", "", "error"));
                                                        }}>
                                                        <div className="detail_user">
                                                            <div className="username_">Mã đại lý</div>
                                                            <div className="username_">
                                                                <input defaultValue={profile.aff ? profile.aff : "admin"} name="aff" />
                                                                <Button type="submit">Xác nhận</Button>
                                                            </div>
                                                        </div>
                                                        <div className="detail_user">
                                                            <div className="username_">SĐT</div>
                                                            <div className="username_">
                                                                <input defaultValue={profile.sdt ? "0" + profile.sdt : ""} name="sdt" />
                                                                <Button type="submit">Xác nhận</Button>
                                                            </div>
                                                        </div>
                                                        <div className="detail_user">
                                                            <div className="username_">Họ tên</div>
                                                            <div className="username_">
                                                                <input defaultValue={profile.name ? profile.name : ""} name="name" />
                                                                <Button type="submit">Xác nhận</Button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </>
                                        ) : null}
                                    </div>
                                    <div className="edit_account_bankl">
                                        <div className="titleitem">Thông tin ngân hàng</div>
                                        <Table sx={{ minWidth: 600 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ padding: "10px" }}>Tên Ngân Hàng</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>STK</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>Người Nhận</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>Hành động</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data != null ? (
                                                    <>
                                                        {data.map((item) => (
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.name_bank}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}> {item.stk}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.fullname}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                    <Button
                                                                        onClick={() => {
                                                                            axios.delete(`${process.env.REACT_APP_API_URL}/bank/delete/${item._id}`).then((res) => {
                                                                                setLoad(false);
                                                                            });
                                                                        }}>
                                                                        Xóa
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() => {
                                                                            axios
                                                                                .get(`${process.env.REACT_APP_API_URL}/bank/user/${item._id}`, {})
                                                                                .then((res) => {
                                                                                    setBank(res.data.data);
                                                                                    setShow(true);
                                                                                })
                                                                                .catch((res) => {
                                                                                    swal("Lấy thông tin không thành công");
                                                                                    setLoad(false);
                                                                                });
                                                                        }}>
                                                                        Sửa
                                                                    </Button>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <div
                                                        style={{
                                                            fontSize: "16px",
                                                            textAlign: "center",
                                                            padding: "10px"
                                                        }}>
                                                        Chưa có
                                                    </div>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <div style={{ clear: "both" }}></div>
                                        <Box>
                                            <br />
                                            <br />
                                            <div className="titleitem">Thống kê xổ số</div>
                                            <div className="col-1-1">
                                                Từ ngày
                                                <DatePicker
                                                    maxDate={new Date()}
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setStartDate(date);
                                                        setLoad(true);
                                                    }}
                                                />
                                            </div>
                                            <div className="col-1-1">
                                                Đến ngày
                                                <DatePicker
                                                    maxDate={new Date()}
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setEndDate(date);
                                                        setLoad(true);
                                                    }}
                                                />
                                            </div>
                                        </Box>
                                        <div style={{ clear: "both" }}></div>
                                        <Table sx={{ minWidth: 600 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}></TableCell>
                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>Nạp</TableCell>
                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>Rút</TableCell>
                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>Cược</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {profile != null ? (
                                                    <>
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: "500", padding: "10px" }}>Thành công/thắng</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.tongnap?.toLocaleString("vi-VN")}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.tongrut?.toLocaleString("vi-VN")}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.totalwin?.toLocaleString("vi-VN")}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: "500", padding: "10px" }}>Thất bại/thua</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.tongnapd?.toLocaleString("vi-VN") || 0}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.tongrutd?.toLocaleString("vi-VN") || 0}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.tongthua?.toLocaleString("vi-VN") || 0}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: "500", padding: "10px" }}>Đang chờ</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.tongnapp?.toLocaleString("vi-VN") || 0}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.tongrutp?.toLocaleString("vi-VN") || 0}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.tongcho?.toLocaleString("vi-VN") || 0}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: "500", padding: "10px" }}>Hủy</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>0</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>0</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{profile?.tonghuy?.toLocaleString("vi-VN") || 0}</TableCell>
                                                        </TableRow>
                                                    </>
                                                ) : (
                                                    <div
                                                        style={{
                                                            fontSize: "16px",
                                                            textAlign: "center",
                                                            padding: "10px"
                                                        }}>
                                                        Chưa có
                                                    </div>
                                                )}
                                            </TableBody>
                                        </Table>

                                        <br />
                                        <br />
                                    </div>
                                </div>
                                <div style={{ maxHeight: "500px", overflowY: "auto", overflowX: "hidden" }}>
                                    <Table sx={{ width: "100%" }} className="table-admin">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ padding: "10px" }}>STT</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Phiên</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Tên người chơi</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Loại giao dịch</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Chi tiết</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Kết quả</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Số tiền</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Đã thành công</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Thời gian</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {history != null ? (
                                                <>
                                                    {history.map((item, index) => (
                                                        <>
                                                            {item.detail.indexOf("Nhận tiền") == -1 && (
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{index + 1}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                        {item?.id_bet?.id_bet ? item?.id_bet?.id_bet : item?.id_bet}
                                                                    </TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.name}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}> {item.game}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px", maxWidth: "400px" }}>{item.detail}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.status ? item?.status : ""}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.money.toLocaleString("vi-VN")}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                        {item.detail.indexOf("Chuyển tiền") > 0 || item.detail.indexOf("RÚT") >= 0 ? "-" : "+"}
                                                                        {item.money_recv.toLocaleString("vi-VN")}
                                                                    </TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{formatDate(new Date(item.time))}</TableCell>
                                                                </TableRow>
                                                            )}
                                                        </>
                                                    ))}
                                                </>
                                            ) : (
                                                <div
                                                    style={{
                                                        fontSize: "16px",
                                                        textAlign: "center",
                                                        padding: "10px"
                                                    }}>
                                                    Đang cập nhật dữ liệu
                                                </div>
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                                <br />
                                <br />
                                {api != null ? (
                                    <>
                                        <div style={{ fontSize: "16px", float: "left" }}>
                                            Tổng cược: <b>{api.reduce((total, item) => total + item.bet, 0).toLocaleString("vi-VN")}</b>
                                        </div>
                                        <div style={{ fontSize: "16px", float: "left", marginLeft: "20px" }}>
                                            Tổng thắng: <b>{api.reduce((total, item) => total + item.payout, 0).toLocaleString("vi-VN")}</b>
                                        </div>
                                        <div style={{ maxHeight: "500px", overflowY: "auto", overflowX: "hidden", clear: "both", marginTop: "20px" }}>
                                            <Table sx={{ width: "100%" }} className="table-admin">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ padding: "10px" }}>ID gd</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Tài khoản</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Số tiền</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Tiền thắng</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Nhà cung cấp</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Loại trò chơi</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Trạng thái</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Thời gian</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {api.map((item, index) => (
                                                        <>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.id}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.member}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.bet.toLocaleString("vi-VN")}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.payout.toLocaleString("vi-VN")}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.site}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.product}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                    {item?.status == 1 ? "Hoàn thành" : item?.status == 0 ? "Chưa hoàn thành" : "Lỗi"}
                                                                </TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{formatDate(new Date(item?.match_time))}</TableCell>
                                                            </TableRow>
                                                        </>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </>
                                ) : null}
                            </Container>
                        </Box>
                    }
                    {isShow === true ? (
                        <>
                            <div className="modal">
                                <div className="modaloverlay">
                                    <i className="ti-close closelogin"></i>
                                </div>
                                <div className="modalbody">
                                    {bank != null ? (
                                        <>
                                            <form onSubmit={handleSubmitBank}>
                                                <div className="modalinner">
                                                    <div className="modalheader"> Sửa thông tin </div>

                                                    <div className="modalform">
                                                        <div className="modalformgroup" style={{ padding: "9px" }}>
                                                            <TextField
                                                                name="name_bank"
                                                                defaultValue={bank.name_bank}
                                                                sx={{ width: "100%" }}
                                                                type="text"
                                                                placeholder="Tên ngân hàng"
                                                            />
                                                        </div>
                                                        <div style={{ padding: "9px" }} className="modalformgroup">
                                                            <TextField name="stk" defaultValue={bank.stk} sx={{ width: "100%" }} type="number" placeholder="STK" />
                                                        </div>
                                                        <div style={{ padding: "9px" }} className="modalformgroup">
                                                            <TextField
                                                                name="fullname"
                                                                defaultValue={bank.fullname}
                                                                sx={{ width: "100%" }}
                                                                type="text"
                                                                placeholder="Tên tài khoản"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="item_btn_form">
                                                        <div className="modalformcontrols">
                                                            <Button type="submit">XÁC NHẬN</Button>
                                                        </div>
                                                        <div className="modalformcontrols">
                                                            <Button onClick={() => setShow(false)}>ĐÓNG</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </>
                                    ) : (
                                        <div>Đang chờ dữ liệu</div>
                                    )}
                                </div>
                            </div>
                        </>
                    ) : null}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}

export default UserProfile;
